import script from "./LoadingDialog.vue?vue&type=script&setup=true&name=LoadingDialog&lang=js"
export * from "./LoadingDialog.vue?vue&type=script&setup=true&name=LoadingDialog&lang=js"

const __exports__ = script;

export default __exports__